/* components/navbar.js */

/* Copyright 2020 - present Tikkl, Inc. */

/*
modification history
--------------------
01q,10nov25,mno  added Find My Tickets menu item
01p,07oct25,mno  updated Host Your Event menu item.
01o,14sep25,mno  updated 'Host Events' menu; typo.
01n,04mar25,mno  renamed 'Host on Tikkl' with 'Sign up to Host'
01m,09dec24,mno  renamed 'Sign up' to 'Host on Tikkl'
01l,26apr24,mno  remove menu: Signup, renamed menu items: Find Events, (org) Sign up.
01k,22aug23,mno  pruned sub-menu "host your event"; added link why-tikkl.
01j,31jul23,mno  added nav to /festivals
01i,13jan23,mno  Organization spl > Org.
01h,14oct22,mno  updated styles.
01g,30aug22,mno  named exports.
01f,20jul22,mno  updated navbar links; show-hide navbar.
01e,08dec21,mno  added signup link.
01d,01dec21,mno  reordered personal menu.
01c,29nov21,mno  renamed menu: 'Host an event'
01b,16nov21,mno  updated user-menu.
01a,09oct20,mno  created.
*/

import React, { useState, useEffect } from "react";
import classNames from 'classnames';
import Notifications from 'react-notify-toast';
import { useStaticQuery, graphql, Link } from "gatsby";
import Img from 'gatsby-image';
import { debounce } from 'lodash';
import ButtonLink from './button_link';
import isPresent from "../lib/is_present";
import tikklUrl from '../lib/tikkl_url';
import ArrowUp from '../../static/ion_ios_arrow_round_up.svg';

const Navbar = (props) => {
  const data = useStaticQuery(graphql`
    query {
      file(relativePath: { eq: "tikkl-logo.png" }){
        childImageSharp {
          fixed(height: 28) {
            ...GatsbyImageSharpFixed_noBase64
          }
        }
      }
    }`
  );

  const [ state, updateState ] = useState({ isBurgerActive: false, isNavHidden: false, pageYOffset: -10, animateNav: false });
  const { userName, orgs } = props;

  // console.log('re-render: state=', state);
  /*
  const orgs = [
    {
      "id": 1624,
      "name": "Aayana Dance Company",
      "subdomain": "aayanadance",
      "url": "/aayanadance"
    },
    {
      "id": 997,
      "name": "Academy of Indian Dances",
      "subdomain": "academyofindiandances",
      "url": "/academyofindiandances"
    },
    {
      "id": 1987,
      "name": "ArtSpire",
      "subdomain": "artspire",
      "url": "/artspire"
    },
    {
      "id": 2218,
      "name": "BITSAA India",
      "subdomain": "bitsaa-india",
      "url": "/bitsaa-india"
    },
    {
      "id": 281,
      "name": "Charsur Arts Foundation",
      "subdomain": "charsurartsfoundation",
      "url": "/charsurartsfoundation"
    },
    {
      "id": 2285,
      "name": "CUSP Services",
      "subdomain": "cusp-services",
      "url": "/cusp-services"
    },
    {
      "id": 2317,
      "name": "Giant Leap",
      "subdomain": "thulasihealyourlife",
      "url": "/thulasihealyourlife"
    },
    {
      "id": 318,
      "name": "IMPL Carnatica",
      "subdomain": "impl-carnatica",
      "url": "/impl-carnatica"
    },
    {
      "id": 832,
      "name": "Jwalit Bharwani",
      "subdomain": "jwalitbharwani",
      "url": "/jwalitbharwani"
    },
    {
      "id": 285,
      "name": "Kalakshetra Foundation",
      "subdomain": "kalakshetra",
      "url": "/kalakshetra"
    },
    {
      "id": 327,
      "name": "Kavan Nrithyalaya ",
      "subdomain": "kavannrithyalaya",
      "url": "/kavannrithyalaya"
    },
    {
      "id": 414,
      "name": "Mahagathe Foundation",
      "subdomain": "mahagathe",
      "url": "/mahagathe"
    },
    {
      "id": 2185,
      "name": "Sangam Shakti",
      "subdomain": "sangamshakti",
      "url": "/sangamshakti"
    },
    {
      "id": 2252,
      "name": "SkydiverShweta",
      "subdomain": "skydivershweta",
      "url": "/skydivershweta"
    },
    {
      "id": 2251,
      "name": "Soul Quest Yogic Cultural Center",
      "subdomain": "yogikiran",
      "url": "/yogikiran"
    },
    {
      "id": 296,
      "name": "The Change Alchemist",
      "subdomain": "thechangealchemist",
      "url": "/thechangealchemist"
    },
    {
      "id": 2320,
      "name": "Thrayi",
      "subdomain": "thrayi",
      "url": "/thrayi"
    },
    {
      "id": 322,
      "name": "Tikkl System",
      "subdomain": "__system__",
      "url": "/__system__"
    },
    {
      "id": 2284,
      "name": "Twins Dance Art Studios",
      "subdomain": "twinsdanceartstudios",
      "url": "/twinsdanceartstudios"
    }
  ];
  */

  const handleScroll = debounce(
    () => updateState(s => {
      const pageYOffset = window.pageYOffset;

      //console.log('state: ', s);

      // ignore calls until the page settles.
      if (s.pageYOffset < 40){
        return {...s, pageYOffset: s.pageYOffset + 1 };
      }

      if (pageYOffset < s.pageYOffset && s.isNavHidden){
        // console.log('showing...');
        return {...s, isNavHidden: false, pageYOffset, animateNav: true };
      }

      if (pageYOffset > s.pageYOffset && !s.isNavHidden){
        // console.log('hiding...');
        return { ...s, isNavHidden: !s.isBurgerActive, pageYOffset, animateNav: true };
      }

      return {...s, pageYOffset };
    }),
    150, {  // wait (debounce period)
      leading:  true, // trigger on leading edge.
      trailing: false,
    }
  );

  const handleMenuTouch = debounce(
    () => updateState(s => ({...s, isNavHidden: false })),
    0, {
      leading: true,
      trailing: false,
    }
  );

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return (() => window.removeEventListener('scroll', handleScroll));
  }, [handleScroll]);

  return (
    <>
      {/* container for react-notify-toast */}
      <Notifications options={{ zIndex: 100, top: '20px' }} />
      <div
        className="tikkl-navbar-control"
        style={{height: '1rem', width: '100%', background: 'transparent', position: 'fixed', top: 0, left: 0, zIndex: 10 }}
        role="presentation"
        aria-label="Menu Show"
        onMouseEnter={() => handleMenuTouch()}
        onTouchStart={() => handleMenuTouch()}
      />
      <nav
        id="tikkl-navbar"
        className={classNames("navbar is-spaced animate__animated", {
          'animate__slideOutUp':  state.animateNav && state.isNavHidden,
          'animate__slideInDown': state.animateNav && !state.isNavHidden,
        })}
        role="navigation"
        aria-label="main navigation"
        style={{ zIndex: 20 }}
      >
        <div className="container">
          <div className="navbar-brand">
            <Link to="/" className="navbar-item">
              <Img fixed={data.file.childImageSharp.fixed} alt="Tikkl Logo" />
            </Link>

            <a
              href="#"
              role="button"
              className={classNames("navbar-burger burger", { 'is-active': state.isBurgerActive })}
              aria-label="menu"
              aria-expanded="false"
              data-target="burger-menu"
              onClick={() => updateState({ ...state, isBurgerActive: !state.isBurgerActive })}
            >
              <span aria-hidden="true"></span>
              <span aria-hidden="true"></span>
              <span aria-hidden="true"></span>
            </a>
          </div>

          <div
            id="tikkl-navbar-menu"
            className={classNames('navbar-menu', { 'is-active': state.isBurgerActive })}
          >
            <div className="navbar-end">
              <a href={tikklUrl('/events')} className="navbar-item">Find Events</a>
              <a href={tikklUrl('/find-tickets')} className="navbar-item">Find My Tickets</a>
              {
                !isPresent(orgs) && (
                  <a href="/host" className="navbar-item">Host Your Event</a>
                )
              }
              {
                isPresent(orgs) && (
                  <div className="navbar-item has-dropdown is-hoverable">
                    <a href="#" className="navbar-link is-dropdown-title">Host Your Event</a>
                    <div className="navbar-dropdown" style={{ left: '-6rem' }}>
                      {
                        isPresent(orgs) && orgs.map((o) => (
                          // eslint-disable-next-line react/jsx-no-target-blank
                          <a target="_blank" href={tikklUrl(`/a/${o.subdomain}`)} key={`org-${o.id}`} className="navbar-item navbar-item">
                            {o.name}
                            <ArrowUp style={{ fill: '#666', height: '1rem', transform: 'rotate(45deg)' }} />
                          </a>
                        ))
                      }
                      <span className="navbar-divider"/>
                      <Link to="/host" className="navbar-item is-primary">Sign up a New Org</Link>
                    </div>
                  </div>
                )
              }

              {
                !isPresent(userName)
                  && <ButtonLink buttonText="Login" href={tikklUrl('/login')} isPrimary isOutlined isRounded/>
              }
              {
                isPresent(userName) && (
                  <div className="navbar-item has-dropdown is-hoverable">
                    <a href="#" className="navbar-link is-dropdown-title">{userName}</a>
                    <div className="navbar-dropdown">
                      <a href={tikklUrl("/me")} className="navbar-item">My Home</a>
                      <a href={tikklUrl("/a/me/tickets")} className="navbar-item">My Tickets</a>
                      <a href={tikklUrl("/a/me/transactions")} className="navbar-item">Transactions</a>
                      <a href={tikklUrl("/a/me/profile")} className="navbar-item">Profile</a>
                      <a href={tikklUrl("/a/me/security")} className="navbar-item">Security</a>
                      <span className="navbar-divider"/>
                      <a href={tikklUrl("/logout?force=true")} className="navbar-item is-primary">Logout</a>
                    </div>
                  </div>
                )
              }
            </div>
          </div>
        </div>
      </nav>
    </>
  );
};

export default Navbar;
